<script>
	import page from 'page';
	import Home from './pages/Home.svelte';
	import About from './pages/About.svelte';
	import Prices from './pages/Prices.svelte';
	
	// set default component
	let current = Home;
	// Map routes to page. If a route is hit the current
	// reference is set to the route's component
	page('/', () => (current = Home));
	page('/about', () => (current = About));
	page('/prices', () => (current = Prices));

	// activate router
	page.start();
  </script>
  
  <main>
	  <center>
		<p style="font-size:30px">
	<nav>
	  <a href="/">Home</a>
		<a href="/about">About</a>
          <a href="/prices">Prices</a>
		

	</nav>
  
	<svelte:component this={current} />

</center>
</main>
